import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import DiaLog from '../../../../components/Dialog';
import { i18n } from '../../../../language';

const useStyles = makeStyles(() => ({
  adsPopContent: () => ({
    fontSize: '1rem',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
  }),
}));

export default function UpdateStatusReminder({ open, handleCancel, handleConfirm, orderInfo }) {
  const classes = useStyles();
  const isAOrCStatus = useMemo(() => {
    return ['A', 'C'].includes(orderInfo?.returnOrderStatus);
  }, [orderInfo]);
  const contentCw = useMemo(() => {
    if (isAOrCStatus) {
      return 'Since the ADS order status has been changed, ADS order cannot be deleted. Are you sure to update equipment status?';
    } else {
      return 'Are you sure to update equipment status? If proceed, the ADS order will be deleted.';
    }
  }, [orderInfo]);

  return (
    <DiaLog
      open={open}
      title={isAOrCStatus ? i18n.t('EQUIPMENT_ADS_POPUP_REMINDER_TITLE') : i18n.t('EQUIPMENT_UPDATE_STATUS')}
      cancel={i18n.t('EQUIPMENT_ADS_POPUP_CANCEL')}
      confirm={i18n.t('EQUIPMENT_ADS_POPUP_CONFIRM')}
      handleClose={handleCancel}
      handleCancel={handleCancel}
      handleConfirm={handleConfirm}
      cancelStyle={{ border: 'unset' }}
      dialogfootStyle={{ borderTop: '1px solid #e4e7eb', paddingTop: '1.5rem' }}
    >
      <div className={classes.adsPopContent}>
        <div>{contentCw}</div>
        <br />
        <div>ADS Order No. {orderInfo?.returnOrderNo}</div>
      </div>
    </DiaLog>
  );
}
